import { useContext, memo, useEffect } from "react";
import { BefGlobalContext } from "@beflam/bef-core";
import React from "react";
import { Loading } from "./Loading";

export function lodingInner(props: { loading: any }) {
    const loading = props.loading;
    return (

        <Loading />
    );
}

const MemoLoading = memo(lodingInner, (prevProps, nextProps) => prevProps.loading === nextProps.loading);

export function LoadingContainer() {
    let globalService = useContext(BefGlobalContext);
    let [showloading, setShowLoading] = React.useState<boolean>(false)

    useEffect(() => {
        const showLoadingEventSub = globalService.showLoadingEvent.subscribe(result => {
            setShowLoading(true);
        });

        const closeLoadingEventSub = globalService.closeLoadingEvent.subscribe(result => {
            setShowLoading(false);
        });

        return () => {
            showLoadingEventSub.unsubscribe();
            closeLoadingEventSub.unsubscribe();
        };
    }, []);
    return (<>
        {
            showloading &&
            <MemoLoading loading={showloading} />
        }
    </>);
}
